import React from 'react';
import { styled } from '@mui/system';
import { colors } from '../theme/index.js';

/**
 * 
 * @returns 
 */
const ModalContent = /*#__PURE__*/React.forwardRef((props, ref) => {
  const customStyle = props.customStyle;
  const StyledDiv = styled('div')(({
    theme
  }) => ({
    '@media (maxWidth: 2300px)': {
      width: '75%'
    },
    '@media (maxWidth: 2000px)': {
      width: '90%'
    },
    '@media (maxWidth: 600px)': {
      width: '95%'
    },
    '@media (maxWidth: 400px)': {
      width: '98%'
    },
    maxWidth: 1350,
    top: '50%',
    left: '50%',
    minWidth: '648px',
    outline: 'none',
    position: 'absolute',
    boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
    transform: 'translate(-50%, -50%)',
    WebkitTransform: 'translate(-50%, -50%)',
    [theme.breakpoints.down('666')]: {
      maxWidth: '75%',
      minWidth: 'unset'
    },
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    borderRadius: '12px',
    padding: '20px',
    backgroundColor: colors.surface,
    ...customStyle
  }));
  const children = props.children;
  return /*#__PURE__*/React.createElement(StyledDiv, props, children);
});
export default ModalContent;